import React from 'react';
import MainProjectListContainer from '../../containers/maintancemng/MainProjectListContainer';

const MaintanceListPage = () => {
  const pageUrl = '/maintancetmng';
  return <MainProjectListContainer pageUrl={pageUrl} />;
};

export default MaintanceListPage;
